import Resource from 'api/resource';
class BadgeResource extends Resource {
  constructor() {
    super('badges/');
  }
}

export { BadgeResource as default };
